"use client";

import Field from "@client/components/formik/field";
import Select from "@client/components/formik/select";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import { FormButton } from "@ui/js/components/buttons/form-button";
import Fieldset from "@ui/js/components/form/fieldset";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "first-responder-type";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function FirstResponderType() {
	const { setFieldValue } = useFormikContext();

	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};

	return (
		<>
			<Fieldset legend="Thank you for keeping us safe. What type of first responder are you?">
				<Field
					{...setUserInteractionDataAttribute(
						`lead-form_step_${INPUT_ID_AND_LABEL_HTMLFOR}`,
					)}
					id={INPUT_ID_AND_LABEL_HTMLFOR}
					name={FIELD_NAME_SELECTOR}
					label="Type of first responder"
				>
					<Select
						id={INPUT_ID_AND_LABEL_HTMLFOR}
						name={FIELD_NAME_SELECTOR}
						onChange={handleChange}
					>
						<option value="" disabled>
							Select an Option
						</option>
						<option value="police_officer">Police Officer</option>
						<option value="firefighter">Firefighter</option>
						<option value="paramedic_or_emt">Paramedic or EMT</option>
						<option value="search_and_rescue">Search and Rescue</option>
						<option value="disaster_response">Disaster Response</option>
						<option value="other">Other</option>
					</Select>
				</Field>
			</Fieldset>
			<FormButton
				{...setUserInteractionDataAttribute(
					`lead-form_submit-button_${INPUT_ID_AND_LABEL_HTMLFOR}`,
				)}
			/>
		</>
	);
}
